import styled from 'styled-components'

export const PageTitle = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 168px;
`

export const PageSubtitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0; 
  border-bottom: 2px dotted rgba(32, 32, 32, 0.5);
  color: rgba(32,32,32,0.7);   
`

export const TooltipHintWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PageSubtitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: row;
  margin-bottom: 96px;
`
export const HeaderNotificationCalendarText = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  margin: 0 8px;
`

export const HeaderNotificationCalendarDate = styled(HeaderNotificationCalendarText)`
  font-weight: 600;
`

export const MapWrapper = styled.div`
  width: 100%;
  height: 500px;
  position: relative;
  margin-top: 16px;
`

export const PlaceholderMap = styled.div`
  width: 100%;
  height: 100%;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 1rem;
`